module.exports = __webpack_public_path__ + "static/media/5DPO20.85ecb339.jpg";